import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30a5b2f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=30a5b2f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5b2f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a5b2f4')) {
      api.createRecord('30a5b2f4', component.options)
    } else {
      api.reload('30a5b2f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30a5b2f4&scoped=true", function () {
      api.rerender('30a5b2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/index.vue"
export default component.exports